exports = module.exports = require("../../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-48a6642a] .el-button--mini {\n  padding: 6px 10px;\n}", ""]);

// exports
